module.exports = __webpack_public_path__ + "img/section4Content1.b7916ad9.png";